import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Person as Person$1 } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { Link } from '../Link/Link.js';

var StyledWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    max-width: calc(768px - 2rem);\n    padding-top: ", ";\n  "], ["\n    width: 100%;\n    max-width: calc(768px - 2rem);\n    padding-top: ", ";\n  "])), theme.spacing[4]);
});
/**
 * The wrapper component for the Person component.
 */
var Wrapper = function (_a) {
  var children = _a.children,
    hasWrapper = _a.hasWrapper;
  return hasWrapper ? jsx(StyledWrapper, {
    children: children
  }) : children;
};
/**
 * The Person component
 *
 * @param {PersonProps} props - The props for the Person component.
 * @returns {JSX.Element} The Person component.
 */
var Person = function (_a) {
  var name = _a.name,
    image = _a.image,
    emailAddress = _a.emailAddress,
    subtitle = _a.subtitle,
    telephoneNumber = _a.telephoneNumber,
    orientation = _a.orientation,
    hasWrapper = _a.hasWrapper;
  return jsx(Wrapper, {
    hasWrapper: hasWrapper,
    children: jsx(Person$1, {
      name: name,
      avatar: __assign(__assign({}, image), {
        size: 80
      }),
      professionalDetails: subtitle,
      contactDetails: [emailAddress ? jsx(Link, {
        to: "mailto:".concat(emailAddress),
        children: emailAddress
      }, "emailAddress") : null, telephoneNumber ? jsx(Link, {
        to: "tel:".concat(telephoneNumber.replace(' ', '')),
        children: telephoneNumber
      }, "telephoneNumber") : null].filter(Boolean),
      orientation: orientation
    })
  });
};
var templateObject_1, templateObject_2;

export { Person };
//# sourceMappingURL=Person.js.map
